import axiosInstance from "config/axiosConfig";

export const formatFileSize = (size: number) => {
  if (size < 1024) return `${size} B`;
  const sizeKB = size / 1024;
  if (sizeKB < 1024) return `${sizeKB.toFixed(1)} KB`;
  const sizeMB = sizeKB / 1024;
  if (sizeMB < 1024) return `${sizeMB.toFixed(1)} MB`;
  const sizeGB = sizeMB / 1024;
  return `${sizeGB.toFixed(1)} GB`;
};

export const toTitleCase = (str: string) => {
  return (str.charAt(0).toUpperCase() + str.slice(1).toLowerCase()).replaceAll(
    "_",
    " "
  );
};

export const getFileSize = async (imageUrl: string) => {
  try {
    const response = await axiosInstance.head(imageUrl);
    return response.headers["content-length"]; // File size in bytes
  } catch (error) {
    console.error("Error fetching file size:", error);
    return null;
  }
};

// Helper function to format keys into readable labels
export const formatLabel = (key: string) => {
  return key
    .replace(/([A-Z])/g, " $1") // Add space before uppercase letters
    .replace(/^./, (str) => str.toUpperCase()); // Capitalize first letter
};
